module.exports = __webpack_public_path__ + "img/logo.6980b57d.svg";